import { t } from 'ttag'
import { useMutation, useQueryClient } from 'react-query'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

import { api, errors } from '@h2/api'
import { managerQuota, searchUsers } from '@main/actions/admin/adminUserActions'
import { Button } from '@h2/components/buttons/button'
import { Field } from '@h2/components/inputs/field'
import { TextInput } from '@h2/components/inputs/text'
import { useForm } from '@h2/common/components/hooks/useForm'

const EditGroup = ({ group }) => {
  const reduxDispatch = useDispatch()
  const queryClient = useQueryClient()
  const { register, isInvalid, handleOnSubmit, dispatch, error } = useForm()

  useEffect(() => {
    dispatch({
      type: 'update',
      payload: { name: group.name }
    })
  }, [group, dispatch])
  const { mutate, isFetching } = useMutation(
    form => {
      return api.fetch(`/admin/users/groups/${group.id}`, {
        method: 'PUT',
        version: 'v1',
        body: JSON.stringify(form)
      })
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries([`groups`], { refetchType: 'all' })
        reduxDispatch(managerQuota())
        setTimeout(() => reduxDispatch(searchUsers(true)), 1000)
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatch({ type: 'validate', payload: formErrors })
        }
      }
    }
  )

  return (
    <form onSubmit={handleOnSubmit(form => mutate(form))}>
      <Field
        label={t`Group Name`}
        desc={error.name}
        status={error.name ? 'error' : 'default'}>
        <TextInput {...register('name')} />
      </Field>
      <div style={{ marginTop: '15px' }}>
        <Button
          type="submit"
          align="center"
          isLoading={isFetching}
          isDisabled={isFetching || isInvalid}>
          {t`Update`}
        </Button>
      </div>
    </form>
  )
}

export { EditGroup }
